var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title is-4"},[_vm._v("Rapportage formats")]),_c('button',{staticClass:"button is-fullwidth is-primary",on:{"click":function($event){return _vm.$router.push({ name: 'create-format' })}}},[_vm._v(" Creëer nieuw format ")]),_c('br'),_c('formatsTable',{attrs:{"formats":_vm.formats}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }